import React from 'react';
import { Link } from 'react-router-dom';

const CARDS = [
  { label: 'Деятельность', href: '/admin/activities', icon: '📋', desc: 'Создание и редактирование разделов деятельности' },
  { label: 'Новости',      href: '/admin/news',       icon: '📰', desc: 'Управление новостями и объявлениями' },
  { label: 'Регионы',      href: '/admin/regions',    icon: '🗺️', desc: 'Управление регионами для фильтрации новостей' },
  { label: 'FAQ',          href: '/admin/faq',        icon: '❓', desc: 'Часто задаваемые вопросы' },
  { label: '📬 Обращения', href: '/admin/feedback',   icon: '📬', desc: 'Просмотр обращений от пользователей' },
  { label: '👥 Сотрудники',href: '/admin/workers',    icon: '👥', desc: 'Сотрудники на странице контактов' },
  { label: 'Слайдер',      href: '/admin/slider',     icon: '🖼️', desc: 'Изображения на главной странице' },
  { label: 'Контакты',     href: '/admin/contacts',   icon: '📞', desc: 'Адрес, телефоны, email организации' },
  { label: 'Как вступить', href: '/admin/join',      icon: '📝', desc: 'Пошаговая инструкция для вступления в профсоюз' },
  { label: 'Документы',    href: '/admin/documents', icon: '📁', desc: 'Загрузка и управление документами' },
  { label: 'Категории',   href: '/admin/categories', icon: '🗂️', desc: 'Категории документов' },
];

export default function AdminDashboard() {
  return (
    <div style={{ padding: 32 }}>
      <h2 style={{ color: '#1a3a6b', marginBottom: 24 }}>Добро пожаловать в админ-панель</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16 }}>
        {CARDS.map(card => (
          <Link key={card.href} to={card.href} style={cardStyle}>
            <span style={{ fontSize: '2rem' }}>{card.icon}</span>
            <strong style={{ color: '#1a3a6b' }}>{card.label}</strong>
            <span style={{ fontSize: '0.82rem', color: '#666' }}>{card.desc}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

const cardStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: 10,
  padding: '24px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  textDecoration: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  transition: 'transform 0.15s, box-shadow 0.15s',
};
